import Vuex, { Store } from 'vuex'
import VueI18n from 'vue-i18n'
import JhiFormatter from './formatter'

import { extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules.umd.js'

import { library, IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faSlack, faJira } from '@fortawesome/free-brands-svg-icons'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft'
import { faBan } from '@fortawesome/free-solid-svg-icons/faBan'
import { faBell } from '@fortawesome/free-solid-svg-icons/faBell'
import { faBook } from '@fortawesome/free-solid-svg-icons/faBook'
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons/faCheckSquare'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
import { faCog } from '@fortawesome/free-solid-svg-icons/faCog'
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye'
import { faHdd } from '@fortawesome/free-solid-svg-icons/faHdd'
import { faHeart } from '@fortawesome/free-solid-svg-icons/faHeart'
import { faList } from '@fortawesome/free-solid-svg-icons/faList'
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
import { faSave } from '@fortawesome/free-solid-svg-icons/faSave'
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt'
import { faSort } from '@fortawesome/free-solid-svg-icons/faSort'
import { faSortDown } from '@fortawesome/free-solid-svg-icons/faSortDown'
import { faSortUp } from '@fortawesome/free-solid-svg-icons/faSortUp'
import { faSquare } from '@fortawesome/free-regular-svg-icons/faSquare'
import { faStoreAlt } from '@fortawesome/free-solid-svg-icons/faStoreAlt'
import { faSync } from '@fortawesome/free-solid-svg-icons/faSync'
import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons/faTachometerAlt'
import { faTasks } from '@fortawesome/free-solid-svg-icons/faTasks'
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons/faTrashAlt'
import { faUserCircle } from '@fortawesome/free-solid-svg-icons/faUserCircle'
import { faWrench } from '@fortawesome/free-solid-svg-icons/faWrench'

import VueCookie from 'vue-cookie'
import Vue2Filters from 'vue2-filters'

import * as filters from '@/shared/date/filters'
import { accountStore } from '@/shared/config/store/account-store'
import { marketplaceStore } from '@/shared/config/store/marketplace-store'

const dateTimeFormats = {
  en: {
    'short': {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
    medium: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
    'long': {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  fr: {
    'short': {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
    medium: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
    'long': {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  // jhipster-needle-i18n-language-date-time-format - JHipster will add/remove format options in this object
}

function initVeeValidate (): void {
  extend('email', {
    ...email,
    message: 'This email is invalid',
  })
  extend('required', {
    ...required,
    message: 'The {_field_} is required',
  })
}

export function initVueApp (vue): void {
  vue.use(VueCookie)
  vue.use(Vue2Filters)
  filters.initFilters()
  initVeeValidate()
}

export function initFortAwesome (): void {
  library.add(
    faSlack,
    faJira,
    faArrowLeft,
    faBan,
    faBell,
    faBook,
    faCheckSquare,
    faChevronRight,
    faCog,
    faEye,
    faHdd,
    faHeart,
    faList,
    faPlus,
    faSave,
    faSearch,
    faSignOutAlt,
    faSort,
    faSortDown,
    faSortUp,
    faSquare as IconDefinition,
    faStoreAlt,
    faSync,
    faTachometerAlt,
    faTasks,
    faTimes,
    faTrashAlt,
    faUserCircle,
    faWrench,
    faExclamationTriangle,
  )
}

export function initI18N (vue): VueI18n {
  vue.use(VueI18n)
  return new VueI18n({
    dateTimeFormats,
    silentTranslationWarn: true,
    formatter: new JhiFormatter(),
  })
}

export function initVueXStore (vue): Store<object> {
  vue.use(Vuex)
  return new Vuex.Store({
    modules: {
      accountStore,
      marketplaceStore,
    },
  })
}
